import axios from "axios";

const syncinstance = axios.create({ baseURL: import.meta.env.VITE_SYNC_API });
 const baseurl = "/sync";

const addsynctable = (payload) =>
  syncinstance.post(`${baseurl}/addsyncTable`, payload);
const getSynedTable = () => syncinstance.get(`${baseurl}/syncTablelist`);

export { addsynctable, getSynedTable };
